import { render } from "./global-graduated-discounts.vue?vue&type=template&id=94be6b6e"
import script from "./global-graduated-discounts.vue?vue&type=script&lang=js"
export * from "./global-graduated-discounts.vue?vue&type=script&lang=js"

import "./global-graduated-discounts.vue?vue&type=style&index=0&id=94be6b6e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__